export default __webpack_public_path__ + "static/media/facebook_privacy_pt.5d2644ff.svg";